import React, { useMemo, useRef } from 'react';
import SelfRegistrationForm from 'components/self-registration/SelfRegistrationForm';
import { PageStoreContext, SelfRegistrationPageStore } from 'store/pages/self-registration/pageStore';
import { useParams } from 'react-router-dom';
import ExistingUserFallback from 'components/self-registration/ExistingUserFallback';
import { observer } from 'mobx-react-lite';
import { createStyles } from '../../globalStyles';

const SelfRegistrationPage = observer((): JSX.Element => {
  const classes = createStyles();
  const { groupId } = useParams<{ groupId: string }>();
  const scrollRef = useRef<HTMLDivElement>(null);

  const pageStore = useMemo(() => new SelfRegistrationPageStore({ groupId }), []);

  const scrollUp = (): void => {
    scrollRef.current?.scrollTo(0, 0);
  };

  return (
    <div className={classes.formWrapper} ref={scrollRef}>
      <PageStoreContext.Provider value={pageStore}>
        {pageStore.isUserInTheSystem ? <ExistingUserFallback /> : <SelfRegistrationForm scrollUp={scrollUp} />}
      </PageStoreContext.Provider>
    </div>
  );
});

export default SelfRegistrationPage;
